import * as Yup from 'yup';

import capsuleValidation from 'src/app/utils/capsuleValidation';

import type { SubmitProps } from './ContactStep';

const initialValues = (props: SubmitProps) => ({
  email: props.email,
});

const schema = Yup.object().shape({
  email: capsuleValidation.email(),
});

export const validation = {
  initialValues,
  schema,
};
